import { CONST_SUMMARY } from '@components/viewer-sessions/table/CustomCell/RenderViewerSession';
import moment from 'moment-timezone';

/* eslint-disable import/prefer-default-export */
export const buildRequest = ({
  clientId,
  sessionId,
  timelineInterval,
  sessionStartTime,
  sessionEndTime,
  isLiveSession = false,
}) => ({
  filter: {
    type: 'and',
    filters: [
      {
        type: 'equal',
        dimension: 'CLIENT_ID',
        value: clientId,
      },
      {
        type: 'equal',
        dimension: 'SESSION_ID',
        value: sessionId,
      },
      {
        type: 'equal',
        dimension: 'SESSION_START_TIMESTAMP',
        value: moment(sessionStartTime).toISOString(),
      },
    ],
  },
  timelineInterval,
  timelineSizeCap: 0,
  summaries: CONST_SUMMARY,
  timelines: [
    'SessionState',
    'SessionEvent',
    'SessionOverviewEvent',
    'Bitrate',
    'Framerate',
    'ConnectionType',
    'CDN',
    'Asset',
    'Error',
    'CustomEvent',
  ],
  options: {},
  meta: {
    sessionStartTime,
    sessionEndTime,
    isLiveSession,
  },
});
